var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city-name thinly-shadowed"},[_c('p',[_vm._v(_vm._s(_vm.$t(`cityNames.${_vm.name}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }